export default "__VITE_ASSET__d226c596__"